import { useContext } from 'react';
import BreadcrumbContext from 'common/contexts/BreadcrumbContext';

export default function useBreadcrumbContext() {
  return useContext(BreadcrumbContext);
}
